import { render, staticRenderFns } from "./Substitution.vue?vue&type=template&id=2794a551&scoped=true&"
import script from "./Substitution.vue?vue&type=script&lang=js&"
export * from "./Substitution.vue?vue&type=script&lang=js&"
import style0 from "./Substitution.vue?vue&type=style&index=0&id=2794a551&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2794a551",
  null
  
)

export default component.exports